<template>
  <div>
    <hLargeIconHeader :text="currentSurvey.name" :icon="'file'"></hLargeIconHeader>

    <div class="row">
      <div class="col">
        <h4>Details</h4>

        <table class="table">
          <tr>
            <th>name</th>
            <td class="ra td-wrap" :class="{ 'text-warning': !currentSurvey.name }" :title="!currentSurvey.name ? 'Name is required' : ''">
              {{ currentSurvey.name || '(empty)' }}
            </td>
          </tr>
          <tr>
            <th>title</th>
            <td class="ra td-wrap" :class="{ 'text-warning': !currentSurvey.title }" :title="!currentSurvey.title ? 'Title is required' : ''">
              {{ currentSurvey.title || '(empty)' }}
            </td>
          </tr>
          <trDetail label="_id" :codeDetail="currentSurvey._id" />
          <trDetail label="createdAt" :time="currentSurvey.createdAt" />
          <trDetail
            label="Diagrams"
            :number="currentSurvey.viz?.diagrams ? currentSurvey.viz.diagrams.length : 0"
            numberSingular="diagram"
            numberPlural="diagrams"
          />
          <tr v-if="currentSurvey.viz && currentSurvey.viz.diagrams && currentSurvey.viz.diagrams.length">
            <th style="border-top: none;"></th>
            <td style="border-top: none; padding-top: 0;">
              <table style="table-layout: fixed; width: 100%; border: none;">
                <tr v-for="(diagram, i) in currentSurvey.viz.diagrams" :key="i">
                  <td class="code-detail" style="border: none; padding: 1px 4px 1px 0; vertical-align: middle;">{{ diagram.type }}</td>
                  <td class="code-detail" style="border: none; padding: 1px 4px 1px 0; font-size: 10px; vertical-align: middle;">{{ quoteText(truncateText(diagram ? diagram.title : '', 15)) }}</td>
                  <td
                    class="code-detail"
                    :class="{ 'text-warning': !!diagramWarning(diagram) }"
                    :title="diagramWarning(diagram) || ''"
                    :style="{ border: 'none', padding: '1px 0', verticalAlign: 'middle', color: (diagram.metasource && !diagramWarning(diagram)) ? '#aaa' : '' }"
                  >{{ diagram.metasource ? ('~' + diagram.metasource.type) : (diagram.id ? diagram.id : '') }}</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <th>Questions</th>
            <td class="ra td-wrap">
              <div class="detail">
                {{ questionCount }} {{ questionCount === 1 ? 'question' : 'questions' }}
                <span
                  :class="{ 'text-warning': questionLayoutWarning }"
                  :title="questionLayoutWarning || ''"
                > on {{ questionPagesCount }} {{ questionPagesCount === 1 ? 'page' : 'pages' }}</span>
              </div>
            </td>
          </tr>
          <tr v-if="currentSurvey.questions && currentSurvey.questions.length">
            <th style="border-top: none;"></th>
            <td style="border-top: none; padding-top: 0;">
              <table style="table-layout: fixed; width: 100%; border: none;">
                <tr v-for="(question, i) in currentSurvey.questions" :key="i">
                  <td class="code-detail" :class="{ 'text-warning': questionTypeWarning(question) }" :title="questionTypeWarning(question)" :style="{ border: 'none', padding: '1px 6px 1px 0', paddingLeft: (question.type !== 'header' && question.type !== 'footer') ? '12px' : '0', verticalAlign: 'middle' }">{{ question.index }}: {{ question.type }}</td>
                  <td class="code-detail" style="border: none; padding: 1px 6px 1px 0; font-size: 10px; vertical-align: middle;">{{ quoteText(truncateText(question ? question.text : '', 15)) }}</td>
                  <td
                    class="code-detail"
                    :class="{ 'text-warning': questionVizWarning(question) }"
                    :title="questionVizWarning(question)"
                    style="border: none; padding: 1px 0; vertical-align: middle;"
                  >{{ question.viz ? question.viz : '' }}</td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>

      <div class="col">
        <h4 :class="{ 'text-warning': notificationWarning }" :title="notificationWarning">Config</h4>

        <textarea class="code-block" v-model="currentSurveyConfig" rows="25" cols="60" disabled></textarea>
      </div>
    </div>

    <div class="mt-5 mb-5">
      <h4>
        <img class="mb-2 mr-1" src="/assets/img/person-plus.svg" width="24" height="24" />
        Assign and Publish
      </h4>userId:
      <form class="edit-form">
        <div class="input-group">
          <select class="form-control" v-model="selectedAssignUserId">
            <option
              v-for="u in allUsers"
              v-bind:value="u.userId"
              v-bind:key="u.userId"
            >{{ u.userId }}</option>
          </select>
        </div>
        <div class="mt-2">
          expireAfterPublishMinutes:
          <input type="number" class="form-control" v-model.number="expireAfterPublishMinutesAssign" min="0" />
        </div>
        <div class="mt-2">
          <span>
            <button
              type="button"
              class="btn btn-primary"
              @click="assignSurvey"
            >Assign and Publish</button>
          </span>
        </div>
      </form>

      <h4 class="mt-4">
        <img class="mb-2 mr-1" src="/assets/img/person-plus.svg" width="24" height="24" />
        Schedule Once
      </h4>userId:
      <form class="edit-form">
        <div class="input-group">
          <select class="form-control" v-model="selectedScheduleOnceUserId">
            <option
              v-for="u in allUsers"
              v-bind:value="u.userId"
              v-bind:key="u.userId"
            >{{ u.userId }}</option>
          </select>
        </div>
        <div>
          publishAt:
          <datetime format="YYYY-MM-DD H:i:s" width="300px" v-model="scheduleOnceDatetime"></datetime>
        </div>
        <div class="mt-2">
          expireAfterPublishMinutes:
          <input type="number" class="form-control" v-model.number="expireAfterPublishMinutesScheduleOnce" min="0" />
        </div>
        <div class="mt-3">
          <span>
            <button type="button" class="btn btn-primary" @click="scheduleSurveyOnce">Schedule Once</button>
          </span>
        </div>
      </form>

      <h4 class="mt-4">
        <img class="mb-2 mr-1" src="/assets/img/person-plus.svg" width="24" height="24" />
        Schedule Series
      </h4>
      <form class="edit-form">
        userId:
        <div class="input-group">
          <select class="form-control" v-model="selectedScheduleSeriesUserId">
            <option
              v-for="u in allUsers"
              v-bind:value="u.userId"
              v-bind:key="u.userId"
            >{{ u.userId }}</option>
          </select>
        </div>
        groupId:
        <div class="input-group">
          <select class="form-control" v-model="selectedScheduleSeriesGroupId">
            <option
              v-for="g in allGroups"
              v-bind:value="g.groupId"
              v-bind:key="g.groupId"
            >{{ g.groupId }}</option>
          </select>
        </div>
        <div>
          scheduleStartDate:
          <datetime format="YYYY-MM-DD" width="300px" v-model="scheduleStartDate"></datetime>scheduleEndDate:
          <datetime format="YYYY-MM-DD" width="300px" v-model="scheduleEndDate"></datetime>
        </div>

        <div>
          <div>
            Hours:
            <datetime format="H:i:s" width="60px" v-model="scheduleHMs[0]"></datetime>
            <datetime format="H:i:s" width="60px" v-model="scheduleHMs[1]"></datetime>
            <datetime format="H:i:s" width="60px" v-model="scheduleHMs[2]"></datetime>
            <datetime 
              v-for="(hm, index) in scheduleHMs.slice(3)" 
              :key="index + 3"
              format="H:i:s" 
              width="60px" 
              v-model="scheduleHMs[index + 3]"
            ></datetime>
          </div>
          <div class="mt-2">
            <button type="button" class="btn btn-sm btn-outline-secondary" @click="addScheduleSlot">+ Add time slot</button>
            <button 
              v-if="scheduleHMs.length > 3" 
              type="button" 
              class="btn btn-sm btn-outline-secondary ml-2" 
              @click="removeScheduleSlot"
            >- Remove last slot</button>
          </div>
        </div>

        <div>
          randomizeMinutes:
          <input type="text" class="form-control" v-model="randomizeMinutes" />
        </div>

        <div class="mt-2">
          expireAfterPublishMinutes:
          <input type="number" class="form-control" v-model.number="expireAfterPublishMinutesScheduleSeries" min="0" />
        </div>

        <div class="mt-4">
          <span>
            <button
              type="button"
              class="btn btn-primary"
              @click="scheduleSurveySeries"
            >Schedule Series</button>
          </span>
        </div>
      </form>

      <h3 class="mt-5">
        <img class="mb-1 mr-1" src="/assets/img/pencil.svg" width="24" height="24" />
        Assignments
      </h3>

      <h4 class="mt-5">
        <img class="mb-1 mr-1" src="/assets/img/person.svg" width="24" height="24" />
        User assignments
      </h4>

      <table class="table table-hover">
        <thead class="thead-light">
          <tr>
            <th style="width: 20%; white-space: nowrap;">Assignment</th>
            <th style="width: 10%; cursor: pointer; user-select: none; color: #0056b3; white-space: nowrap;" @click="setSortField('user')">
              User <span style="display: inline-block; width: 1em;">{{ sortField === 'user' ? (sortDir === 'asc' ? '↑' : '↓') : '' }}</span>
            </th>
            <th style="width: 20%; cursor: pointer; user-select: none; color: #0056b3; white-space: nowrap;" @click="setSortField('createdAt')">
              createdAt <span style="display: inline-block; width: 1em;">{{ sortField === 'createdAt' ? (sortDir === 'asc' ? '↑' : '↓') : '' }}</span>
            </th>
            <th style="width: 20%; cursor: pointer; user-select: none; color: #0056b3; white-space: nowrap;" @click="setSortField('publishAt')">
              publishAt <span style="display: inline-block; width: 1em;">{{ sortField === 'publishAt' ? (sortDir === 'asc' ? '↑' : '↓') : '' }}</span>
            </th>
            <th style="width: 10%; white-space: nowrap;">Notif</th>
            <th style="width: 10%; white-space: nowrap;">Track</th>
            <th style="width: 20%; cursor: pointer; user-select: none; color: #0056b3; white-space: nowrap;" @click="setSortField('answered')">
              Answered <span style="display: inline-block; width: 1em;">{{ sortField === 'answered' ? (sortDir === 'asc' ? '↑' : '↓') : '' }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(assignment, index) in sortedUserAssignments" 
            :key="index"
            @dblclick="goToAssignment(assignment)"
          >
            <tdAssignmentNameLink :data="{assignment}" />
            <td>
              <a :href="'/users/' + assignment.userId">{{ assignment.userId }}</a>
            </td>
            <td>{{ getCalendar(assignment.createdAt) }}</td>
            <td>{{ getCalendar(assignment.publishAt) }}</td>
            <td>
              <img
                class="mr-1"
                v-if="assignment.publishNotifiedAt"
                src="/assets/img/phone-vibrate.svg"
                title="publishNotifiedAt"
              />
              <img
                class="mr-1"
                v-if="assignment.expireNotifiedAt"
                src="/assets/img/phone-vibrate.svg"
                title="expireNotifiedAt"
              />
            </td>
            <td>
              <img
                class="mr-1"
                v-if="assignment.firstOpenedAt"
                src="/assets/img/envelope-open.svg"
                title="firstOpenedAt"
              />
              <img
                class="mr-1"
                v-if="assignment.dataset"
                src="/assets/img/check.svg"
                title="dataset"
              />
            </td>
            <td>{{ assignment.dataset ? getCalendar(assignment.dataset.createdAt) : "Unanswered" }}</td>
            <td />
          </tr>
        </tbody>
      </table>

      <div class="mt-4" v-if="!isGeneratingDownload && !(datasetCsv || datasetJson)">
        <span class="m-2">
          Generate
        </span>
        <span class="m-2">
          <a href="javascript:;" @click="generateCsv">CSV</a>
        </span>
        <span target="m-2">
          <a href="javascript:;" @click="generateJson">JSON</a>
        </span>
      </div>

      <div class="mt-4" v-if="isGeneratingDownload">
        <span class="m-2">
          Generating...
        </span>
      </div>

      <div class="mt-4" v-if="!isGeneratingDownload && (datasetCsv || datasetJson)">
        <span class="m-2" v-if="datasetCsv">
          <a 
            v-bind:href="`data:text/csv;charset=utf-8,` + encodeURIComponent(datasetCsv)"
            target="_blank" 
            v-bind:download='currentSurvey.id || currentSurvey.name + ".csv"'
            >
            Download CSV
          </a>
        </span>
        <span target="m-2" v-if="datasetJson">
          <a 
            v-bind:href="`data:text/json;charset=utf-8,` + encodeURIComponent(datasetJson)"
            target="_blank" 
            v-bind:download='currentSurvey.id || currentSurvey.name + ".json"'
            >
            Download JSON
          </a>
        </span>
      </div>

      <h4 class="mt-5">
        <img class="mb-1 mr-1" src="/assets/img/people.svg" width="24" height="24" />
        Group assignments
      </h4>

      <table class="table table-hover">
        <thead class="thead-light">
          <tr>
            <th style="width: 20%; white-space: nowrap;">Assignment</th>
            <th style="width: 10%; cursor: pointer; user-select: none; color: #0056b3; white-space: nowrap;" @click="setSortField('group')">
              Group <span style="display: inline-block; width: 1em;">{{ sortField === 'group' ? (sortDir === 'asc' ? '↑' : '↓') : '' }}</span>
            </th>
            <th style="width: 20%; cursor: pointer; user-select: none; color: #0056b3; white-space: nowrap;" @click="setSortField('createdAt')">
              createdAt <span style="display: inline-block; width: 1em;">{{ sortField === 'createdAt' ? (sortDir === 'asc' ? '↑' : '↓') : '' }}</span>
            </th>
            <th style="width: 20%; cursor: pointer; user-select: none; color: #0056b3; white-space: nowrap;" @click="setSortField('publishFrom')">
              publishFrom <span style="display: inline-block; width: 1em;">{{ sortField === 'publishFrom' ? (sortDir === 'asc' ? '↑' : '↓') : '' }}</span>
            </th>
            <th style="width: 20%; white-space: nowrap;">publishTo</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(assignment, index) in sortedGroupAssignments" 
            :key="index"
            @dblclick="goToAssignment(assignment)"
          >
            <tdAssignmentNameLink :data="{assignment}" />
            <td>
              <a :href="'/groups/' + assignment.groupId">{{ assignment.groupId }}</a>
            </td>
            <td>{{ getCalendar(assignment.createdAt) }}</td>
            <td>{{ getCalendar(assignment.publishFrom) }}</td>
            <td>{{ getCalendar(assignment.publishTo) }}</td>
          </tr>
        </tbody>
      </table>


      <div class="mt-4" v-if="!isGeneratingResultsDownload && !(datasetResultsCsv || datasetResultsJson)">
        <span class="m-2">
          Generate
        </span>
        <span class="m-2">
          <a href="javascript:;" @click="generateResultsCsv">CSV</a>
        </span>
        <span target="m-2">
          <a href="javascript:;" @click="generateResultsJson">JSON</a>
        </span>
      </div>

      <div class="mt-4" v-if="isGeneratingResultsDownload">
        <span class="m-2">
          Generating...
        </span>
      </div>

      <div class="mt-4" v-if="!isGeneratingResultsDownload && (datasetResultsCsv || datasetResultsJson)">
        <span class="m-2" v-if="datasetResultsCsv">
          <a 
            v-bind:href="`data:text/csv;charset=utf-8,` + encodeURIComponent(datasetResultsCsv)"
            target="_blank" 
            v-bind:download='currentSurvey.id ? currentSurvey.id : currentSurvey.name + "_results.csv"'
            >
            Download CSV
          </a>
        </span>
        <span target="m-2" v-if="datasetResultsJson">
          <a 
            v-bind:href="`data:text/json;charset=utf-8,` + encodeURIComponent(datasetResultsJson)"
            target="_blank" 
            v-bind:download='currentSurvey.id ? currentSurvey.id : currentSurvey.name + "_results.json"'
            >
            Download JSON
          </a>
        </span>
      </div>

    </div>
  </div>

  <!-- <div class="edit-form">
      <h4>Edit Survey</h4>
      <form>
        <div class="form-group">
          <label for="title">Title</label>
          <input type="text" class="form-control" id="title" v-model="currentSurvey.title" />
        </div>

        <div class="form-group">
          <label>
            <strong>Status:</strong>
          </label>
          {{ currentSurvey.published ? "Published" : "Pending" }}
        </div>
      </form>

      <button
        class="badge badge-primary mr-2"
        v-if="currentSurvey.published"
        @click="updatePublished(false)"
      >UnPublish</button>
      <button v-else class="badge badge-primary mr-2" @click="updatePublished(true)">Publish</button>

      <button class="badge badge-danger mr-2" @click="deleteSurvey">Delete</button>

      <button type="submit" class="badge badge-success" @click="updateSurvey">Update</button>
      <p>{{ updateMessage }}</p>
  </div>-->
</template>

<script>
import moment from "moment";
import datetime from "vuejs-datetimepicker";

import SurveyDataService from "../services/SurveyDataService";
import UserDataService from "../services/UserDataService";
import GroupDataService from '../services/GroupDataService';
import AssignmentDataService from "../services/AssignmentDataService";

import tdAssignmentNameLink from "./table/td/tdAssignmentNameLink";
import hLargeIconHeader from "./h/hLargeIconHeader";
import trDetail from "./table/tr/trDetail";

export default {
  components: {
    datetime,
    tdAssignmentNameLink,
    hLargeIconHeader,
    trDetail
  },
  name: "survey",
  data() {
    return {
      currentSurvey: {
        title: "",
        _id: "",
        status: "",
        createdAt: "",
        questions: []
      },
      currentSurveyConfig: "",
      updateMessage: "",
      assignMessage: "",
      allUsers: [],
      allGroups: [],
      selectedAssignUserId: "",
      expireAfterPublishMinutesAssign: 60,

      selectedScheduleOnceUserId: "",
      scheduleOnceDatetime: "",
      expireAfterPublishMinutesScheduleOnce: 60,

      selectedScheduleSeriesUserId: "",
      selectedScheduleSeriesGroupId: "",
      scheduleStartDate: "",
      scheduleEndDate: "",
      scheduleHMs: ["", "", ""],
      randomizeMinutes: 0,
      expireAfterPublishMinutesScheduleSeries: 60,

      assignments: [],

      isGeneratingDownload: false,
      datasetJson: null,
      datasetCsv: null,

      isGeneratingResultsDownload: false,
      datasetResultsJson: null,
      datasetResultsCsv: null,
      sortField: "publishAt",
      sortDir: "asc"
    };
  },
  computed: {
    questionCount: function() {
      return (this.currentSurvey.questions || []).filter(q => q.type !== "header" && q.type !== "footer").length;
    },
    questionPagesCount: function() {
      return (this.currentSurvey.questions || []).length;
    },
    hasQuestionHeader: function() {
      return (this.currentSurvey.questions || []).some(q => q.type === "header");
    },
    hasQuestionFooter: function() {
      return (this.currentSurvey.questions || []).some(q => q.type === "footer");
    },
    questionLayoutWarning: function() {
      const questions = this.currentSurvey.questions || [];
      const warnings = [];

      if (!this.hasQuestionHeader && !this.hasQuestionFooter) {
        warnings.push("missing header and footer");
      } else {
        if (!this.hasQuestionHeader) {
          warnings.push("missing header");
        }
        if (!this.hasQuestionFooter) {
          warnings.push("missing footer");
        }
      }

      if (questions.length > 0 && questions[0].type !== "header") {
        warnings.push("first question is not a header");
      }
      if (questions.length > 0 && questions[questions.length - 1].type !== "footer") {
        warnings.push("last question is not a footer");
      }

      // Index must be an integer
      const nonIntegerIndices = questions
        .filter(q => q.index === undefined || q.index === null || !Number.isInteger(q.index))
        .map((q, i) => i);
      if (nonIntegerIndices.length > 0) {
        warnings.push("non-integer index at position(s): " + nonIntegerIndices.join(", "));
      }

      // Question indices must be unique
      const indices = questions.map(q => q.index);
      const seen = new Set();
      const duplicates = [];
      indices.forEach(idx => {
        if (seen.has(idx)) {
          if (!duplicates.includes(idx)) duplicates.push(idx);
        } else {
          seen.add(idx);
        }
      });
      if (duplicates.length > 0) {
        warnings.push("duplicate index(es): " + duplicates.join(", "));
      }

      // Question indices must be continuous and start at 0
      const sortedIndices = [...indices].filter(i => Number.isInteger(i)).sort((a, b) => a - b);
      if (sortedIndices.length > 0) {
        if (sortedIndices[0] !== 0) {
          warnings.push("indices do not start at 0");
        } else {
          const hasGap = sortedIndices.some((val, i) => i > 0 && val !== sortedIndices[i - 1] + 1);
          if (hasGap) {
            warnings.push("indices are not continuous");
          }
        }
      }

      if (warnings.length === 0) {
        return "";
      }
      return "Warning: " + warnings.join("; ") + ".";
    },
    diagramIds: function() {
      const diagrams = (this.currentSurvey.viz && this.currentSurvey.viz.diagrams) || [];
      return diagrams
        .map(d => this.normalizeId(d.id))
        .filter(id => id);
    },
    questionVizIds: function() {
      return (this.currentSurvey.questions || [])
        .map(q => this.normalizeId(q.viz))
        .filter(id => id);
    },
    piecePosCount: function() {
      return (this.currentSurvey.questions || []).reduce((total, question) => {
        const choices = question.choices || [];
        return total + choices.filter(c => c.piecePos !== undefined && c.piecePos !== null).length;
      }, 0);
    },
    notificationWarning: function() {
      const warnings = [];
      if (!this.currentSurvey.publishNotificationTitle) {
        warnings.push("publishNotificationTitle");
      }
      if (!this.currentSurvey.publishNotificationBody) {
        warnings.push("publishNotificationBody");
      }
      if (!this.currentSurvey.expireNotificationTitle) {
        warnings.push("expireNotificationTitle");
      }
      if (!this.currentSurvey.expireNotificationBody) {
        warnings.push("expireNotificationBody");
      }
      return warnings.length > 0 ? "Warning: Missing required notification fields: " + warnings.join(", ") + "." : "";
    },
    userAssignments: function() {
      return this.assignments.filter(a => a.userId);
    },
    groupAssignments: function() {
      return this.assignments.filter(a => a.groupId);
    },
    sortedUserAssignments: function() {
      return this.sortAssignments(this.userAssignments);
    },
    sortedGroupAssignments: function() {
      return this.sortAssignments(this.groupAssignments);
    }
  },
  watch: {
    selectedScheduleSeriesUserId(newVal) {
      if (newVal) {
        this.selectedScheduleSeriesGroupId = "";
      }
    },
    selectedScheduleSeriesGroupId(newVal) {
      if (newVal) {
        this.selectedScheduleSeriesUserId = "";
      }
    }
  },
  methods: {
    quoteText(text) {
      if (!text) {
        return "";
      }
      return '"' + text + '"';
    },
    truncateText(value, maxLength) {
      const text = value ? String(value) : "";
      const limit = maxLength || 15;
      if (text.length <= limit) {
        return text;
      }
      return text.slice(0, limit) + "...";
    },
    normalizeId(value) {
      if (value === undefined || value === null) {
        return "";
      }
      return String(value);
    },
    questionTypeWarning(question) {
      if (!question) {
        return "";
      }
      const warnings = [];
      if (!question.text) {
        warnings.push("text required");
      }
      if (!question.type) {
        warnings.push("type required");
      }
      if (question.index === undefined || question.index === null || !Number.isInteger(question.index)) {
        warnings.push("index must be integer");
      }

      const allQuestions = this.currentSurvey.questions || [];
      const allIndices = allQuestions.map(q => q.index).filter(i => Number.isInteger(i));

      // includeIf checks
      if (question.includeIf !== undefined && question.includeIf !== null) {
        const { ifIndex, ifValue } = question.includeIf;
        if (!Number.isInteger(ifIndex)) {
          warnings.push("includeIf.ifIndex must be integer");
        } else if (!allIndices.includes(ifIndex)) {
          warnings.push("includeIf.ifIndex (" + ifIndex + ") does not reference an existing question");
        } else {
          const referencedQuestion = allQuestions.find(q => q.index === ifIndex);
          const choicesLength = (referencedQuestion && referencedQuestion.choices) ? referencedQuestion.choices.length : 0;
          if (!Number.isInteger(ifValue)) {
            warnings.push("includeIf.ifValue must be integer");
          } else if (ifValue < 0 || ifValue >= choicesLength) {
            warnings.push("includeIf.ifValue (" + ifValue + ") out of range for question " + ifIndex + " (choices: " + choicesLength + ")");
          }
        }
      }

      // skip checks
      if (question.skip !== undefined && question.skip !== null) {
        const { ifChosen, goto: gotoVal } = question.skip;
        const ownChoicesLength = (question.choices) ? question.choices.length : 0;
        if (!Number.isInteger(ifChosen)) {
          warnings.push("skip.ifChosen must be integer");
        } else if (ifChosen < 0 || ifChosen >= ownChoicesLength) {
          warnings.push("skip.ifChosen (" + ifChosen + ") out of range (own choices: " + ownChoicesLength + ")");
        }
        if (!Number.isInteger(gotoVal)) {
          warnings.push("skip.goto must be integer");
        } else if (!allIndices.includes(gotoVal)) {
          warnings.push("skip.goto (" + gotoVal + ") does not reference an existing question");
        } else if (Number.isInteger(question.index) && gotoVal <= question.index) {
          warnings.push("skip.goto (" + gotoVal + ") must be greater than current index (" + question.index + ")");
        }
      }

      return warnings.length > 0 ? "Warning: " + warnings.join("; ") + "." : "";
    },
    questionVizWarning(question) {
      if (!question || !question.viz) {
        return "";
      }
      const vizId = this.normalizeId(question.viz);
      return this.diagramIds.includes(vizId) ? "" : "Warning: no matching diagram.";
    },
    diagramWarning(diagram) {
      if (!diagram || !diagram.id) {
        return "";
      }
      const diagramId = this.normalizeId(diagram.id);
      const isReferencedByQuestion = this.questionVizIds.includes(diagramId);
      if (!isReferencedByQuestion && !diagram.metasource) {
        return "Warning: id not used by questions and no metasource.";
      }
      if (diagram.type === "puzzle" && !diagram.metasource) {
        if (this.piecePosCount !== 16) {
          return "Warning: puzzle diagram expects 16 piecePos choices across all questions, found " + this.piecePosCount + ".";
        }
      }
      return "";
    },
    sortAssignments(assignments) {
      const sorted = [...assignments];
      sorted.sort((a, b) => {
        let aVal, bVal;
        
        if (this.sortField === "createdAt") {
          aVal = a.createdAt || 0;
          bVal = b.createdAt || 0;
        } else if (this.sortField === "publishAt") {
          aVal = a.publishAt || a.publishFrom || 0;
          bVal = b.publishAt || b.publishFrom || 0;
        } else if (this.sortField === "publishFrom") {
          aVal = a.publishFrom || 0;
          bVal = b.publishFrom || 0;
        } else if (this.sortField === "user") {
          aVal = a.userId || "";
          bVal = b.userId || "";
        } else if (this.sortField === "group") {
          aVal = a.groupId || "";
          bVal = b.groupId || "";
        } else if (this.sortField === "answered") {
          aVal = a.dataset ? 1 : 0;
          bVal = b.dataset ? 1 : 0;
        }
        
        if (aVal < bVal) return this.sortDir === "asc" ? -1 : 1;
        if (aVal > bVal) return this.sortDir === "asc" ? 1 : -1;
        return 0;
      });
      return sorted;
    },
    setSortField(field) {
      if (this.sortField === field) {
        this.sortDir = this.sortDir === "asc" ? "desc" : "asc";
      } else {
        this.sortField = field;
        this.sortDir = "asc";
      }
    },
    addScheduleSlot() {
      this.scheduleHMs.push("");
    },
    removeScheduleSlot() {
      if (this.scheduleHMs.length > 3) {
        this.scheduleHMs.pop();
      }
    },
    getCalendar(dt) {
      if (!dt) return "";
      return moment(dt).calendar();
    },
    getSurvey(_id) {
      SurveyDataService.getSurvey(_id)
        .then(response => {
          this.currentSurvey = response.data;
          this.currentSurveyConfig = JSON.stringify(
            this.currentSurvey,
            null,
            2
          );
        })
        .catch(e => {
          console.log(e);
        });
    },

    getUsers() {
      UserDataService.getAll()
        .then(response => {
          this.allUsers = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },

    getGroups() {
      GroupDataService.getAll()
        .then(response => {
          this.allGroups = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },

    getAssignmentsOfSurvey(id) {
      AssignmentDataService.getAssignmentsOfSurvey(id)
        .then(response => {
          this.assignments = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },

    updatePublished(status) {
      console.log(status);
      var data = {
        _id: this.currentSurvey._id,
        title: this.currentSurvey.title,
        published: status
      };

      SurveyDataService.update(this.currentSurvey._id, data)
        .then(response => {
          this.currentSurvey.published = status;
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    updateSurvey() {
      SurveyDataService.update(this.currentSurvey._id, this.currentSurvey)
        .then(response => {
          console.log(response.data);
          this.updateMessage = "The Survey was updated successfully!";
        })
        .catch(e => {
          console.log(e);
          this.updateMessage = "Update failed.";
        });
    },

    assignSurvey() {
      SurveyDataService.assignSurvey(
        this.currentSurvey._id,
        this.selectedAssignUserId,
        this.expireAfterPublishMinutesAssign > 0 ? this.expireAfterPublishMinutesAssign : 60
      )
        .then(response => {
          console.log("Banana");
          console.log(response.data);
          this.assignMessage = "The user has been assigned the survey.";
          console.log(this.currentSurvey._id);
          this.getAssignmentsOfSurvey(this.currentSurvey._id,)
        })
        .catch(e => {
          console.log(e);
          this.updateMessage = "Assignment failed.";
          alert(this.updateMessage);
        });
    },

    scheduleSurveyOnce() {
      SurveyDataService.scheduleSurveyOnce(
        this.currentSurvey._id,
        this.selectedScheduleOnceUserId,
        this.scheduleOnceDatetime,
        this.expireAfterPublishMinutesScheduleOnce > 0 ? this.expireAfterPublishMinutesScheduleOnce : 60
      )
        .then(response => {
          console.log(response.data);
          this.assignMessage =
            "The survey series has been scheduled at " +
            this.scheduleOnceDatetime +
            ".";
          this.getAssignmentsOfSurvey(this.currentSurvey._id,)
        })
        .catch(e => {
          console.log(e);
          this.updateMessage = "Scheduling once failed.";
          alert(this.updateMessage);
        });
    },

    scheduleSurveySeries() {
      SurveyDataService.scheduleSurveySeries(
        this.currentSurvey._id,
        this.selectedScheduleSeriesUserId,
        this.selectedScheduleSeriesGroupId,
        this.scheduleStartDate,
        this.scheduleEndDate,
        this.scheduleHMs,
        this.randomizeMinutes,
        this.expireAfterPublishMinutesScheduleSeries > 0 ? this.expireAfterPublishMinutesScheduleSeries : 60
      )
        .then(response => {
          console.log(response.data);
          this.assignMessage = "The survey series has been scheduled.";
          this.getAssignmentsOfSurvey(this.currentSurvey._id,)
        })
        .catch(e => {
          console.log(e);
          this.updateMessage = "Scheduling series failed.";
          alert(this.updateMessage);
        });
    },

    deleteSurvey() {
      SurveyDataService.delete(this.currentSurvey._id)
        .then(response => {
          console.log(response.data);
          this.$router.push({ name: "surveys" });
        })
        .catch(e => {
          console.log(e);
        });
    },

    goToAssignment(assignment) {
      window.location.href = "/assignments/" + assignment._id;
    },

    generateCsv() {
      this.isGeneratingDownload = true
      SurveyDataService.getCsv(this.currentSurvey._id)
        .then(apiResponse => {
          this.datasetCsv = apiResponse.data
          this.isGeneratingDownload = false
      })
    },

    generateJson() {
      this.isGeneratingDownload = true
      SurveyDataService.getJson(this.currentSurvey._id)
        .then(apiResponse => {
          this.datasetJson = JSON.stringify(apiResponse.data)
          this.isGeneratingDownload = false
      })
    },

    generateResultsCsv() {
      this.isGeneratingResultsDownload = true
      SurveyDataService.getResultsCsv(this.currentSurvey._id)
        .then(apiResponse => {
          this.datasetResultsCsv = apiResponse.data
          this.isGeneratingResultsDownload = false
      })
    },

    generateResultsJson() {
      this.isGeneratingDoisGeneratingResultsDownloadwnload = true
      SurveyDataService.getResultsJson(this.currentSurvey._id)
        .then(apiResponse => {
          this.datasetResultsJson = JSON.stringify(apiResponse.data)
          this.isGeneratingResultsDownload = false
      })
    }
  },
  
  mounted() {
    moment.locale("en-ca");
    this.updateMessage = "";
    this.assignMessage = "";
    this.getSurvey(this.$route.params.id);
    this.getUsers();
    this.getGroups();
    this.getAssignmentsOfSurvey(this.$route.params.id);
  }
};
</script>

<style>
.edit-form {
  max-width: 300px;
}
.list {
  max-width: 100%;
}
.code-block {
  font-family: monospace, Arial, sans-serif;
  font-size: smaller;
  background: #ddd;
  color: #666;
}
.code-detail {
  font-family: monospace, Arial, sans-serif;
  font-size: smaller;
  color: #666;
}
.td-wrap {
  word-break: break-word;
}
.h-spacer {
  margin-right: 200;
}
</style>